// extracted by mini-css-extract-plugin
export var altaccent = "Card-module--altaccent--aa484";
export var arrow = "Card-module--arrow--95fc1";
export var bound = "Card-module--bound--1fa3c";
export var card = "Card-module--card--22505";
export var casestudy = "Card-module--casestudy--7edb2";
export var content = "Card-module--content--4e1a8";
export var date = "Card-module--date--542e4";
export var eyebrow = "Card-module--eyebrow--ac2e1";
export var feature = "Card-module--feature--acffb";
export var full = "Card-module--full--62453";
export var greyBackground = "Card-module--grey-background--84335";
export var image = "Card-module--image--ec873";
export var lightBlueBackground = "Card-module--light-blue-background--7b195";
export var link = "Card-module--link--dd492";
export var metadata = "Card-module--metadata--1198b";
export var noLink = "Card-module--no-link--6f75a";
export var plain = "Card-module--plain--e6219";
export var quarter = "Card-module--quarter--7975f";
export var row = "Card-module--row--9a341";
export var shadow = "Card-module--shadow--b2fb5";
export var share = "Card-module--share--3d233";
export var visual = "Card-module--visual--855b9";
export var whiteBackground = "Card-module--white-background--df4c2";